import { FiberForm } from 'Container/App/interface';
import { FormType } from 'Container/App/enum';

/**
 * Checks given variable if its a string ant not empty
 * @param value the variable to be validated
 * @returns boolean
 */
export const isNotEmptyString = (value: any): boolean => Boolean(value && 'string' === typeof value);

/**
 * Checks given variable if its a string ant not empty
 * and if an array is provided also checks whether it includes the value
 * @param value the variable to be validated
 * @param array
 * @returns boolean
 */
export const isValidId = (value: any, array?: string[]) => {
    let result = isNotEmptyString(value);

    if (array?.length) {
        result = array.includes(value);
    }

    return result;
};

export const formIsValid = (form: FiberForm) => {
    switch (form.type) {
        case FormType.ADDRESS:
            return Boolean(
                form.city.length &&
                form.street.length &&
                form.number.length);
        case FormType.LMS:
            return Boolean(
                form.firstName?.length &&
                form.lastName?.length &&
                form.email?.length);
    }
};

export const isNotNullOrUndefined = <T>(value: T | null | undefined): value is T =>
    null !== value && undefined !== value;
